

export const changesInLibraries = (): void => {
  $.widget("ui.menu", $.ui.menu, {
    _activate: function () {
      //pour ne pas faire l'action (une errer de chargement si "this.active" a la valeur null) -> p.exemple bouton "Créer +" gérer d'absences,
      //mode imbriqué, en utilisant la souris et la touche "enter"
      if (this.active) {
        this._superApply(arguments);//eslint-disable-line
      }
    }
  });
}
